import type { MediaType } from "@/types/media";

export const TYPE_LABELS: Record<MediaType, string> = {
  tv: "电视剧",
  movie: "电影",
  variety: "综艺",
};

export const TYPE_PATHS: Record<MediaType, string> = {
  tv: "/category/tv",
  movie: "/category/movie",
  variety: "/category/variety",
};

export const TYPE_ICONS: Record<MediaType, string> = {
  tv: "ri-tv-2-line",
  movie: "ri-film-line",
  variety: "ri-mic-line",
};

export const TYPE_TAGLINES: Record<MediaType, string> = {
  tv: "追更热剧，一集不落",
  movie: "光影佳作，影院之外",
  variety: "轻松下饭，快乐加倍",
};

export const TYPE_DESCRIPTIONS: Record<MediaType, string> = {
  tv: "汇聚最新电视剧作品，支持筛选和浏览。电视剧频道包括都市、古装、悬疑等热门题材资源。",
  movie: "汇聚最新电影作品，支持筛选和浏览。电影频道包括科幻、爱情、动作等经典类型资源。",
  variety: "汇聚最新综艺节目，支持筛选和浏览。综艺频道包括音乐、美食、旅行等热门品类资源。",
};

export const REGIONS = [
  "全部",
  "中国大陆",
  "中国香港",
  "中国台湾",
  "韩国",
  "日本",
  "美国",
];

export const YEARS = ["全部", "2025", "2024", "2023"];

export const GENRE_OPTIONS = [
  "全部",
  "都市",
  "古装",
  "悬疑",
  "科幻",
  "爱情",
  "动作",
  "青春",
  "动画",
  "美食",
  "音乐",
  "旅行",
  "竞技",
  "真人秀",
  "纪实",
];

export const SORT_OPTIONS = [
  { value: "latest", label: "最新" },
  { value: "hot", label: "热门" },
  { value: "rating", label: "评分" },
];

export const PAGE_SIZE = 8;